/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Input for evaluating a definition against a real event.
 * 
 * The event does not have to be running under this definition. "What would this configuration
 * do to that event" is the question worth answering, and restricting it to events already
 * using the definition would make it useless for checking a change before saving it.
 * @export
 * @interface DryRunRequest
 */
export interface DryRunRequest {
    /**
     * 
     * @type {string}
     * @memberof DryRunRequest
     */
    event: string;
}

/**
 * Check if a given object implements the DryRunRequest interface.
 */
export function instanceOfDryRunRequest(value: object): value is DryRunRequest {
    if (!('event' in value) || value['event'] === undefined) return false;
    return true;
}

export function DryRunRequestFromJSON(json: any): DryRunRequest {
    return DryRunRequestFromJSONTyped(json, false);
}

export function DryRunRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DryRunRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'event': json['event'],
    };
}

export function DryRunRequestToJSON(json: any): DryRunRequest {
    return DryRunRequestToJSONTyped(json, false);
}

export function DryRunRequestToJSONTyped(value?: DryRunRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event': value['event'],
    };
}

